{
  "columns": {
    "item": "การ์ด",
    "consignor": "ผู้ฝาก",
    "sold": "ขายเมื่อ",
    "sold_price": "ขายได้",
    "commission": "ค่าคอมร้าน",
    "card_fee": "ส่วนแบ่งค่าธรรมเนียมบัตร",
    "proceeds": "ผู้ฝากได้",
    "paid": "จ่ายแล้ว",
    "outstanding": "ค้างจ่าย",
    "status": "สถานะ"
  },
  "channel": {
    "web": "เว็บ",
    "pos": "หน้าร้าน"
  },
  "settlement_status": {
    "not_applicable": "ไม่มีที่ต้องจ่าย",
    "awaiting_payout": "รอจ่าย",
    "processing": "กำลังจ่าย",
    "adjusted": "มีการเปลี่ยน · ตรวจก่อน",
    "partially_paid": "จ่ายบางส่วน",
    "paid": "จ่ายแล้ว"
  },
  "payout_status": {
    "draft": "ร่าง",
    "processing": "รอโอน",
    "paid": "จ่ายแล้ว",
    "cancelled": "ยกเลิก"
  },
  "method": {
    "bank_transfer_manual": "โอนธนาคาร",
    "cash": "เงินสดที่ร้าน",
    "store_credit": "เครดิตร้าน"
  },
  "method_hint": {
    "bank_transfer_manual": "โอนที่ธนาคาร แล้วบันทึกที่นี่",
    "cash": "จ่ายจากลิ้นชักเครื่องขาย ผู้ฝากเซ็นใบรับเงิน",
    "store_credit": "เครดิตใช้ในร้าน อายุไม่เกิน 6 เดือน"
  },
  "codes": {
    "service_fee": "ค่าคอมร้าน",
    "payment_fee": "ส่วนแบ่งค่าธรรมเนียมบัตร",
    "shipping": "ค่าส่ง",
    "grading_fee": "ค่าเกรด",
    "other": "อื่นๆ",
    "refund_reversal": "คืนเงิน"
  },
  "skip": {
    "below_minimum": "ยอดยังไม่ถึงขั้นต่ำของผู้ฝาก",
    "nothing_due": "ไม่มีที่ต้องจ่าย",
    "carry_exceeds_outstanding": "ผู้ฝากค้างร้านมากกว่ายอดที่รอจ่าย",
    "payout_in_progress": "มีการจ่ายที่กำลังทำอยู่",
    "consignor_closed": "ผู้ฝากปิดแล้ว",
    "no_payout_destination": "ยังไม่มีบัญชีธนาคาร"
  },
  "settlements": {
    "intro": "การ์ดฝากขายที่ขายได้ทั้งหมด: ขายได้เท่าไร ร้านได้เท่าไร ผู้ฝากได้เท่าไร ตัวเลขมาจากระบบของร้าน",
    "pay": "จ่ายเงินผู้ฝาก",
    "only_of": "เฉพาะยอดขายของ",
    "everyone": "ทุกคน",
    "view_awaiting": "รอจ่าย",
    "view_adjusted": "มีการเปลี่ยน · ตรวจก่อน",
    "month": "เดือนที่ขาย",
    "all_months": "ทุกเดือน",
    "custom_range": "{{from}} – {{to}}"
  },
  "deductions": {
    "title": "ยอดขาย",
    "intro": "ผู้ฝากได้เท่าไรจากการ์ดใบนี้",
    "load_failed": "โหลดยอดขายนี้ไม่ได้",
    "caption": "วิธีคิดเงินที่ผู้ฝากได้",
    "refunded": "คืนเงินลูกค้า",
    "needs_review": "มีการเปลี่ยนหลังขาย (คืนเงินหรือราคา) ตรวจตัวเลขก่อนจ่าย",
    "add_title": "หักค่าส่ง ค่าเกรด หรือค่าอื่นๆ",
    "kind": "หักค่าอะไร",
    "amount": "จำนวน",
    "note": "หมายเหตุถึงผู้ฝาก",
    "add": "หักรายการนี้",
    "add_hint": "ผู้ฝากเห็นบรรทัดนี้ใน 精算書",
    "remove": "ลบ {{label}}",
    "remove_title": "ลบรายการหักนี้?",
    "locked": "ยอดนี้จ่ายแล้ว (หรือปิดแล้ว) เปลี่ยนรายการหักไม่ได้",
    "recalculate": "คิดใหม่ด้วยค่าคอมวันนี้",
    "recalculated": "คิดใหม่แล้ว",
    "consequence": "ระบบจะคิดเงินที่ผู้ฝากได้ใหม่",
    "confirm": "บันทึก",
    "saved": "บันทึกแล้ว คิดเงินผู้ฝากใหม่แล้ว",
    "payments": "จ่ายด้วย"
  },
  "wizard": {
    "title": "จ่ายเงินผู้ฝาก",
    "intro": "จ่ายใคร ยอดไหน ด้วยวิธีไหน การจ่ายเงินจริงทำนอกระบบ (ธนาคารหรือเงินสด) ที่นี่คือการบันทึก",
    "load_failed": "คำนวณคนที่ต้องจ่ายไม่ได้",
    "steps": "ขั้นตอน",
    "step_who": "จ่ายใคร",
    "step_sales": "ยอดไหน",
    "step_how": "วิธีจ่าย",
    "who_title": "คนที่จะได้เงิน",
    "nobody": "ตอนนี้ไม่มีใครรอรับเงิน",
    "nobody_body": "การ์ดฝากขายที่ขายได้จะขึ้นที่นี่เมื่อสรุปยอดแล้ว",
    "sales_one": "{{count}} รายการ",
    "sales_other": "{{count}} รายการ",
    "skipped_one": "มี {{count}} คนที่ไม่ได้จ่ายรอบนี้",
    "skipped_other": "มี {{count}} คนที่ไม่ได้จ่ายรอบนี้",
    "include_below": "จ่ายคนที่ยอดยังไม่ถึงขั้นต่ำด้วย",
    "sales_title": "จ่ายยอดไหน",
    "carry": "หักยอดที่ค้างร้าน",
    "pays": "จ่าย",
    "amount_on_save": "ระบบคิดยอดตอนบันทึก",
    "how_title": "จ่ายด้วยวิธีไหน",
    "method": "วิธีจ่าย",
    "transfer_when": "การโอนธนาคาร",
    "paid_later": "จะโอนตอนนี้ (ทำไฟล์โอน แล้วบันทึกทีหลัง)",
    "paid_now": "โอนแล้ว",
    "paid_on": "จ่ายวันที่",
    "paid_on_hint": "วันที่เงินออก (เวลาญี่ปุ่น)",
    "reference": "เลขอ้างอิงการโอน",
    "reference_hint": "จากใบยืนยันของธนาคาร (振込受付番号)",
    "slip": "สลิปโอน (ไม่บังคับ)",
    "cash_location": "จ่ายจากเครื่องขายของร้าน",
    "cash_location_hint": "เงินสดออกจากเครื่องขายที่เปิดกะอยู่ของร้านนี้",
    "signature": "รูปใบรับเงินที่เซ็นแล้ว",
    "store_credit_note": "เครดิตร้านใช้ในร้านได้ไม่เกิน 6 เดือน (資金決済法)",
    "no_bank_file": "ไฟล์โอนจะทำให้เมื่อจ่ายทุกยอดของทุกคนที่เลือกพร้อมกัน",
    "summary": "สรุป",
    "total": "รวม",
    "next": "ถัดไป",
    "back": "ย้อนกลับ",
    "create": "สร้างรายการจ่าย",
    "record_paid": "บันทึกว่าจ่ายแล้ว",
    "confirm_title": "สร้างรายการจ่าย?",
    "confirm_paid_title": "บันทึกการจ่าย?",
    "confirm_later_one": "{{count}} รายการจะรอการโอนของคุณ",
    "confirm_later_other": "{{count}} รายการจะรอการโอนของคุณ",
    "confirm_paid_one": "ระบบแจ้งผู้ฝากและส่ง 精算書",
    "confirm_paid_other": "ระบบแจ้งผู้ฝาก {{count}} คนและส่ง 精算書",
    "done_one": "สร้างรายการจ่าย {{count}} รายการ",
    "done_other": "สร้างรายการจ่าย {{count}} รายการ",
    "some_failed": "มีบางคนที่จ่ายไม่ได้:",
    "to_list": "รายการจ่ายทั้งหมด"
  },
  "bank_file": {
    "download": "ดาวน์โหลดไฟล์โอน",
    "saved": "บันทึกไฟล์โอนแล้ว เปิดด้วยโปรแกรมของธนาคารหรือ Excel",
    "next_steps": "อัปโหลดไฟล์ที่ธนาคาร โอนเงิน แล้วบันทึกว่าจ่ายแล้วทีละรายการ"
  },
  "statement": {
    "open": "精算書",
    "making": "กำลังทำ 精算書…",
    "failed": "ยังทำ 精算書 ไม่ได้ ระบบจะลองใหม่",
    "mailed": "ผู้ฝากได้รับ 精算書 ทางอีเมลและในพอร์ทัล"
  },
  "payouts": {
    "intro": "การจ่ายเงินผู้ฝากทั้งหมด รายการที่รอโอนให้บันทึกที่นี่หลังเงินออกแล้ว",
    "pay": "จ่ายเงินผู้ฝาก",
    "reference": "เลขที่",
    "amount": "จำนวน",
    "method": "วิธี",
    "paid_on": "จ่ายวันที่",
    "statement": "精算書",
    "statement_ready": "พร้อม",
    "view_processing": "รอโอน"
  },
  "detail": {
    "title": "รายการจ่าย",
    "load_failed": "โหลดรายการจ่ายนี้ไม่ได้",
    "paid_on": "จ่ายวันที่",
    "run": "รอบจ่าย {{reference}}",
    "sales": "ยอดขายในรายการนี้",
    "this_payout": "รอบนี้",
    "record_title": "บันทึกการโอน",
    "record_intro": "หลังเงินออกจากธนาคาร: ใส่วันที่และเลขอ้างอิงการโอน",
    "record": "บันทึกว่าจ่ายแล้ว",
    "record_consequence": "ระบบแจ้งผู้ฝากและส่ง 精算書",
    "paid_done": "บันทึกว่าจ่ายแล้ว",
    "cancel": "ยกเลิกรายการนี้",
    "cancel_title": "ยกเลิกรายการจ่ายนี้?",
    "cancel_consequence": "ยังไม่ได้จ่าย ยอดขายรอรอบจ่ายถัดไป",
    "cancelled": "ยกเลิกแล้ว"
  },
  "problems": {
    "reference": "ใส่เลขอ้างอิงการโอน",
    "signature": "เพิ่มรูปใบรับเงินที่เซ็นแล้ว"
  }
}
